import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";

export default createSelector(
  [getUserAgent],
  (userAgent) =>
    userAgent.isEdge ||
    userAgent.source === "Mozilla/5.0 (Windows NT 10.0; Win64; x64)",
);
